export function contracttoBuyandSellForeclosure2026() {
return [   // Release 2025-12-31 07:54:53
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 267.742,
   left: 456.12,
   width: 109.92,
   height: 12.440
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 375.982,
   left: 116.88,
   width: 420.00,
   height: 12.440
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 406.2,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 419.88,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 433.8,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.542,
   left: 119.16,
   width: 420.00,
   height: 12.440
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 466.222,
   left: 118.44,
   width: 420.12,
   height: 12.440
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.72,
   left: 433.68,
   width: 135.00,
   height: 12.44
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.639,
   left: 58.9093,
   width: 520.4237,
   height: 172.6144
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 697.0984,
   left: 117.96,
   width: 445.08,
   height: 14.9673
}
,
{
   page: 1,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.12,
   left: 279.902,
   width: 55.080,
   height: 12.36
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 135.12,
   left: 84.6218,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 135.12,
   left: 161.662,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 135.12,
   left: 255.262,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 135.12,
   left: 351.982,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 250.747,
   left: 69.7094,
   width: 505.0696,
   height: 185.407
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Personal Property Agreement", 
   isText: false,
   type: "checkbox",
   top: 436.84,
   left: 77.9018,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 527.839,
   left: 72.3277,
   width: 504.1493,
   height: 97.262
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 627.56,
   left: 122.502,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 627.56,
   left: 168.382,
   width: 10.080,
   height: 10.08
}
,
{
   page: 1,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.4,
   left: 90.0219,
   width: 300.0001,
   height: 12.36
}
,
{
   page: 1,
   name: "Storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.6182,
   left: 161.062,
   width: 395.040,
   height: 12.3600
}
,
{
   page: 2,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.091,
   left: 70.6912,
   width: 506.9468,
   height: 79.600
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 141.64,
   left: 121.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 141.64,
   left: 166.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 181.48,
   left: 104.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 207.88,
   left: 398.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 207.88,
   left: 443.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 263.037,
   left: 57.6003,
   width: 515.1877,
   height: 71.893
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 357.04,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 368.837,
   left: 69.3821,
   width: 500.4699,
   height: 51.251
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.4,
   left: 359.52,
   width: 144.96,
   height: 12.48
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 437.32,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Other Rights Relating to Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 461.383,
   left: 69.3821,
   width: 501.3899,
   height: 55.587
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 519.56,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 595.24,
   left: 274.56,
   width: 287.532,
   height: 11.498
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 614.04,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 626.875,
   left: 69.3821,
   width: 502.4749,
   height: 48.510
}
,
{
   page: 3,
   name: "Time of Day Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.12,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 61.8,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Alternative Earnest Money Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 61.8,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 87.72,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Record Title Deadline and Tax Certificate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 87.72,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 101.4,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "Record Title Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 101.4,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 115.08,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "OffRecord Title Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 115.08,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 128.76,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "OffRecord Title Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 128.76,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 142.44,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Title Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 142.44,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 156.36,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 156.36,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 182.04,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Association Documents Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 182.04,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 195.72,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Association Documents Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 195.72,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 221.4,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "Sellers Property Disclosure Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 221.4,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 235.08,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 235.08,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 260.76,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "New Loan Application Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 260.76,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 274.68,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "New Loan Terms Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 274.68,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 288.36,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "New Loan Availability Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 288.36,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 302.04,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Buyers Credit Information Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 302.04,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 315.72,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 315.72,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 329.4,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Existing Loan Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.4,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 343.32,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Existing Loan Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 343.32,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 357,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "Loan Transfer Approval Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 357,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 370.68,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.68,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 396.36,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Appraisal Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 396.36,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 410.04,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Appraisal Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 410.04,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 423.72,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Appraisal Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 423.72,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 449.64,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "New ILC or New Survey Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 449.64,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 463.32,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "New ILC or New Survey Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 463.32,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 477,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 477,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 502.68,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Water Rights Examination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 502.68,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 516.36,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Mineral Rights Examination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.36,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 530.28,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Inspection Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 530.28,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 543.96,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Inspection Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 543.96,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 557.64,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Inspection Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 557.64,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 571.32,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Property Insurance Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 571.32,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 585,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 585,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 598.68,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Due Diligence Documents Objection Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 598.68,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 612.6,
   left: 307.68,
   width: 69.72,
   height: 12.6
}
,
{
   page: 3,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 612.6,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 626.28,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Conditional Sale Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 626.28,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 639.96,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "LeadBased Paint Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 639.96,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 665.64,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Closing Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 665.64,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 679.32,
   left: 307.68,
   width: 69.72,
   height: 12.84
}
,
{
   page: 3,
   name: "Possession Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 679.32,
   left: 378.72,
   width: 193.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Possession Time", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 693.24,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 706.92,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Acceptance Deadline Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 706.92,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 3,
   name: "Acceptance Deadline Time", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 720.6,
   left: 378.72,
   width: 193.56,
   height: 12.6
}
,
{
   page: 3,
   name: "Deadlines Extra Row Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 734.28,
   left: 63.84,
   width: 39.24,
   height: 11.60
}
,
{
   page: 3,
   name: "Deadlines Extra Row Event", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 734.28,
   left: 104.4,
   width: 201.96,
   height: 11.60
}
,
{
   page: 3,
   name: "Date Deadlines Extra Row", 
   fontSize: 9,
   type: "date",
   top: 734.28,
   left: 307.68,
   width: 69.72,
   height: 12.60
}
,
{
   page: 3,
   name: "Deadlines Extra Row", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 734.28,
   left: 378.72,
   width: 193.56,
   height: 12.60
}
,
{
   page: 4,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 301.32,
   left: 130.92,
   width: 10.56,
   height: 10.56
}
,
{
   page: 4,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 301.32,
   left: 175.56,
   width: 10.56,
   height: 10.56
}
,
{
   page: 4,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 398.4,
   left: 300.797,
   width: 94.960,
   height: 13.36
}
,
{
   page: 4,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.96,
   left: 414.597,
   width: 83.240,
   height: 12.60
}
,
{
   page: 4,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.28,
   left: 414.597,
   width: 83.240,
   height: 12.60
}
,
{
   page: 4,
   name: "Amount Assumption Balance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 447.6,
   left: 414.597,
   width: 83.240,
   height: 12.6
}
,
{
   page: 4,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.92,
   left: 414.597,
   width: 83.240,
   height: 12.60
}
,
{
   page: 4,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 480.24,
   left: 414.597,
   width: 83.240,
   height: 12.60
}
,
{
   page: 4,
   name: "Price Item 7 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.68,
   left: 99.84,
   width: 52.68,
   height: 12.52
}
,
{
   page: 4,
   name: "Price Item 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.68,
   left: 153.84,
   width: 133.80,
   height: 12.52
}
,
{
   page: 4,
   name: "Amount Extra Row 1 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.68,
   left: 300.797,
   width: 94.960,
   height: 13.36
}
,
{
   page: 4,
   name: "Price Item 8 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 513.28,
   left: 99.84,
   width: 52.68,
   height: 12.76
}
,
{
   page: 4,
   name: "Price Extra Row Item 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 513.28,
   left: 153.84,
   width: 133.80,
   height: 12.76
}
,
{
   page: 4,
   name: "Amount Purchase Extra Row 2 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 512.946,
   left: 414.597,
   width: 83.240,
   height: 12.600
}
,
{
   page: 4,
   name: "Amount Extra Row 2 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 513.28,
   left: 301.67,
   width: 94.96,
   height: 13.36
}
,
{
   page: 4,
   name: "Amount Purchase Extra Row Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.182,
   left: 414.597,
   width: 83.240,
   height: 12.600
}
,
{
   page: 4,
   name: "Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 528.895,
   left: 414.597,
   width: 83.240,
   height: 12.600
}
,
{
   page: 4,
   name: "CALCULATE Amount Purchase Price PLUS Amount Extra Row 1 Debit PLUS Amount Extra Row 2 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.44,
   left: 300.797,
   width: 94.960,
   height: 13.36
}
,
{
   page: 4,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Purchase Extra Row Credit PLUS Amount Purchase Extra Row 2 Credit PLUS Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 545.131,
   left: 414.597,
   width: 83.240,
   height: 12.600
}
,
{
   page: 4,
   name: "Seller Concessions", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.92,
   left: 331.2,
   width: 95.04,
   height: 12.36
}
,
{
   page: 4,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 657.12,
   left: 408.6,
   width: 159.96,
   height: 12.36
}
,
{
   page: 4,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 670.32,
   left: 197.64,
   width: 160.08,
   height: 12.36
}
,
{
   page: 5,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 391.32,
   left: 434.28,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 391.32,
   left: 483.24,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 541.56,
   left: 89.64,
   width: 10.56,
   height: 10.56
}
,
{
   page: 5,
   name: "Checkbox Group Loan FHA", 
   isText: false,
   type: "checkbox",
   top: 540.84,
   left: 177.96,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Checkbox Group Loan VA", 
   isText: false,
   type: "checkbox",
   top: 540.84,
   left: 227.64,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Checkbox Group Loan Bond", 
   isText: false,
   type: "checkbox",
   top: 540.84,
   left: 269.88,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 540.84,
   left: 321.24,
   width: 11.28,
   height: 11.28
}
,
{
   page: 5,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 538.8,
   left: 369.72,
   width: 195.00,
   height: 12.84
}
,
{
   page: 5,
   name: "Amount FHA VA Closing Costs Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.56,
   left: 96.48,
   width: 75.00,
   height: 12.84
}
,
{
   page: 5,
   name: "Amount Assumption At", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.16,
   left: 299.04,
   width: 69.96,
   height: 12.84
}
,
{
   page: 5,
   name: "Assumption Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.16,
   left: 389.28,
   width: 135.00,
   height: 12.84
}
,
{
   page: 5,
   name: "Assumption Rate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 682.08,
   left: 253.44,
   width: 50.04,
   height: 12.84
}
,
{
   page: 5,
   name: "Checkbox Group AssumptionEscrow Real Estate Taxes", 
   isText: false,
   type: "checkbox",
   top: 712.68,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group AssumptionEscrow Property Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 712.68,
   left: 175.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group AssumptionEscrow Mortgage Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 712.68,
   left: 325.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Checkbox Group AssumptionEscrow Other", 
   isText: false,
   type: "checkbox",
   top: 726.36,
   left: 94.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "AssumptionEscrow Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 723.36,
   left: 108.12,
   width: 394.92,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Loan Transfer Fee Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 32.64,
   left: 305.4,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Percent Assumption Loan Interest Rate Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.56,
   left: 155.76,
   width: 45.00,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption New Payment Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.56,
   left: 417.84,
   width: 70.08,
   height: 12.84
}
,
{
   page: 6,
   name: "Assumption New Payment Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 60.24,
   left: 74.64,
   width: 140.04,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Cash At Closing Increase Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 87.84,
   left: 177.6,
   width: 70.08,
   height: 12.84
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will", 
   isText: false,
   type: "checkbox",
   top: 118.44,
   left: 116.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not", 
   isText: false,
   type: "checkbox",
   top: 118.44,
   left: 161.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 132.36,
   left: 298.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery At Closing", 
   isText: false,
   type: "checkbox",
   top: 146.04,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Assumption Release of Liability Paid By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 156.96,
   left: 74.64,
   width: 174.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Amount Assumption Release of Liability Max Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 156.96,
   left: 372.72,
   width: 69.96,
   height: 12.84
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 293.64,
   left: 89.64,
   width: 10.56,
   height: 10.56
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 293.64,
   left: 142.2,
   width: 10.56,
   height: 10.56
}
,
{
   page: 6,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 305.28,
   left: 89.04,
   width: 55.08,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount FHA Minimum Appraised Value", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 563.28,
   left: 472.8,
   width: 90.0,
   height: 10.68
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 87.96,
   left: 75.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 87.96,
   left: 125.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Seller", 
   isText: false,
   type: "checkbox",
   top: 188.04,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Checkbox Abstract of Title", 
   isText: false,
   type: "checkbox",
   top: 227.64,
   left: 308.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Buyer", 
   isText: false,
   type: "checkbox",
   top: 258.12,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will", 
   isText: false,
   type: "checkbox",
   top: 315,
   left: 374.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will Not", 
   isText: false,
   type: "checkbox",
   top: 315,
   left: 416.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Buyer", 
   isText: false,
   type: "checkbox",
   top: 382.2,
   left: 330.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Seller", 
   isText: false,
   type: "checkbox",
   top: 381.24,
   left: 383.88,
   width: 11.28,
   height: 11.28
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Split", 
   isText: false,
   type: "checkbox",
   top: 395.64,
   left: 89.64,
   width: 11.28,
   height: 11.28
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Other", 
   isText: false,
   type: "checkbox",
   top: 395.64,
   left: 317.16,
   width: 11.28,
   height: 11.28
}
,
{
   page: 9,
   name: "WhoPaysOEC Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.12,
   left: 365.52,
   width: 198.00,
   height: 13.44
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Seller", 
   isText: false,
   type: "checkbox",
   top: 414.76,
   left: 278.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Buyer", 
   isText: false,
   type: "checkbox",
   top: 414.76,
   left: 327.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Website Metro District", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 391.329,
   left: 65.6549,
   width: 481.2011,
   height: 13.491
}
,
{
   page: 11,
   name: "Checkbox Group ILCorSurvey New ILC", 
   isText: false,
   type: "checkbox",
   top: 530.52,
   left: 91.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Checkbox Group ILCorSurvey New Survey", 
   isText: false,
   type: "checkbox",
   top: 543.72,
   left: 91.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Survey Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 541.2,
   left: 222,
   width: 319.92,
   height: 12.36
}
,
{
   page: 11,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 574.2,
   left: 283.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 574.2,
   left: 331.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysNewILCorSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 628.68,
   left: 146.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysNewILCorSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 628.68,
   left: 194.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "WhoPaysNewILCorSurvey Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627.494,
   left: 254.837,
   width: 323.674,
   height: 33.345
}
,
{
   page: 11,
   name: "Delivery ILC", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 671.52,
   left: 260.4,
   width: 300.0,
   height: 12.36
}
,
{
   page: 13,
   name: "Other Documents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 375.056,
   left: 85.0913,
   width: 481.2017,
   height: 63.237
}
,
{
   page: 14,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does", 
   isText: false,
   type: "checkbox",
   top: 35.88,
   left: 470.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does Not", 
   isText: false,
   type: "checkbox",
   top: 35.88,
   left: 515.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox Well There is no well", 
   isText: false,
   type: "checkbox",
   top: 62.04,
   left: 205.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does", 
   isText: false,
   type: "checkbox",
   top: 62.04,
   left: 330.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does Not", 
   isText: false,
   type: "checkbox",
   top: 62.04,
   left: 375,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "If English is not the Sellers principal language", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 113.52,
   left: 207.84,
   width: 185.04,
   height: 11.88
}
,
{
   page: 15,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are", 
   isText: false,
   type: "checkbox",
   top: 348.12,
   left: 473.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are Not", 
   isText: false,
   type: "checkbox",
   top: 348.12,
   left: 513.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.48,
   left: 74.64,
   width: 290.04,
   height: 11.88
}
,
{
   page: 15,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 534.84,
   left: 68.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 534.84,
   left: 230.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 534.84,
   left: 342.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 534.84,
   left: 453.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 548.76,
   left: 68.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton DeedType Deed Other", 
   isText: false,
   type: "checkbox",
   top: 548.76,
   left: 230.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 546.72,
   left: 245.88,
   width: 200.04,
   height: 11.88
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 73.32,
   left: 158.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 73.32,
   left: 208.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 73.32,
   left: 256.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 88.2,
   left: 194.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "ClosingServicesFeePaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 86.16,
   left: 237.96,
   width: 294.96,
   height: 11.88
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 187.32,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 187.32,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 187.32,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 187.32,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 233.4,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 233.4,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 233.4,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 233.4,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 303.72,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 303.72,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 303.72,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 303.72,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 337.8,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 337.8,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 337.8,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 337.8,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 384.84,
   left: 137.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 384.84,
   left: 187.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 384.84,
   left: 236.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 384.84,
   left: 442.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Amount Water Transfer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.52,
   left: 82.08,
   width: 95.04,
   height: 11.88
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Water DistrictMunicipality", 
   isText: false,
   type: "checkbox",
   top: 432.12,
   left: 99.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Water Stock", 
   isText: false,
   type: "checkbox",
   top: 432.12,
   left: 248.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Augmentation Membership", 
   isText: false,
   type: "checkbox",
   top: 448.92,
   left: 99.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Small Domestic Water Company", 
   isText: false,
   type: "checkbox",
   top: 448.92,
   left: 248.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Other", 
   isText: false,
   type: "checkbox",
   top: 448.92,
   left: 409.82,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "WaterTransferFees Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 446.88,
   left: 423.48,
   width: 144.96,
   height: 11.88
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 479.16,
   left: 198.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 479.16,
   left: 248.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 479.16,
   left: 297,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 479.16,
   left: 503.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 524.52,
   left: 112.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 524.52,
   left: 163.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 524.52,
   left: 211.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 524.52,
   left: 418.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 593.64,
   left: 163.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 101.16,
   left: 89.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 114.36,
   left: 89.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 140.76,
   left: 89.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 139.92,
   left: 133.56,
   width: 415.08,
   height: 10.68
}
,
{
   page: 17,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 158.04,
   left: 212.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 158.04,
   left: 340.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Other Prorations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 207.12,
   left: 89.04,
   width: 440.04,
   height: 10.68
}
,
{
   page: 17,
   name: "Radiobutton AssociationAssessmentsObligation Buyer", 
   isText: false,
   type: "checkbox",
   top: 305.16,
   left: 228.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton AssociationAssessmentsObligation Seller", 
   isText: false,
   type: "checkbox",
   top: 305.16,
   left: 278.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 354.111,
   left: 75.9276,
   width: 482.5104,
   height: 14.145
}
,
{
   page: 17,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 423.12,
   left: 444.48,
   width: 75.24,
   height: 10.68
}
,
{
   page: 18,
   name: "Checkbox Specific Performance", 
   isText: false,
   type: "checkbox",
   top: 404.76,
   left: 114.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 560.64,
   left: 74.64,
   width: 320.04,
   height: 12.36
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Seller", 
   isText: false,
   type: "checkbox",
   top: 87.24,
   left: 83.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 20,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 87.12,
   left: 96.76,
   width: 35.04,
   height: 9.96
}
,
{
   page: 20,
   name: "Amount Seller Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 87.12,
   left: 248.6,
   width: 75.0,
   height: 9.96
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Buyer", 
   isText: false,
   type: "checkbox",
   top: 129.48,
   left: 83.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 20,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 129.36,
   left: 101.76,
   width: 35.04,
   height: 9.96
}
,
{
   page: 20,
   name: "Amount Buyer Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 129.36,
   left: 255.6,
   width: 75.0,
   height: 9.96
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Sellers Brokerage", 
   isText: false,
   type: "checkbox",
   top: 171.24,
   left: 83.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 20,
   name: "Percent Seller Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.36,
   left: 101.76,
   width: 35.04,
   height: 9.72
}
,
{
   page: 20,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.12,
   left: 255.6,
   width: 75.0,
   height: 9.96
}
,
{
   page: 20,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 267.71,
   left: 45.8184,
   width: 539.4566,
   height: 488.6933
}
,
{
   page: 21,
   name: "Sellers language", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 251.76,
   left: 433.2,
   width: 130.08,
   height: 12.12
}
,
{
   page: 21,
   name: "Buyers 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 342.44,
   left: 71.88,
   width: 354.00,
   height: 12.12
}
,
{
   page: 21,
   name: "Buyers 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 359.28,
   left: 220.32,
   width: 342.00,
   height: 12.12
}
,
{
   page: 21,
   name: "TextDateAndTime Cancel Contract", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.36,
   left: 56.64,
   width: 156.00,
   height: 12.12
}
,
{
   page: 21,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 56.946,
   left: 58.9093,
   width: 526.3657,
   height: 72.400
}
,
{
   page: 21,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 137.455,
   left: 58.9093,
   width: 526.3657,
   height: 70.437
}
,
{
   page: 21,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 574.64,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 612.68,
   left: 137.76,
   width: 435.00,
   height: 14.04
}
,
{
   page: 21,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627.44,
   left: 137.76,
   width: 170.04,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627.44,
   left: 450.24,
   width: 120.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.44,
   left: 137.76,
   width: 435.00,
   height: 13.80
}
,
{
   page: 21,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.88,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 703.04,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.92,
   left: 137.76,
   width: 170.04,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.92,
   left: 450.24,
   width: 120.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 732.92,
   left: 137.76,
   width: 435.00,
   height: 13.80
}
,
{
   page: 22,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 28.677,
   left: 138.138,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 168.327,
   left: 138.964,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.487,
   left: 138.142,
   width: 429.960,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.367,
   left: 138.142,
   width: 170.040,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.367,
   left: 450.622,
   width: 120.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 236.367,
   left: 138.142,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 264.327,
   left: 138.142,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.367,
   left: 138.142,
   width: 429.960,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.127,
   left: 138.142,
   width: 170.040,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.127,
   left: 450.622,
   width: 120.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 332.127,
   left: 138.142,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.087,
   left: 138.142,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 390.567,
   left: 138.142,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Does_3", 
   isText: false,
   type: "checkbox",
   top: 560.32,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Does Not acknowledge receipt of Earnest Money deposit Broker agrees that if Brokerage Firm is the", 
   isText: false,
   type: "checkbox",
   top: 560.32,
   left: 130.44,
   width: 10.08,
   height: 10.554
}
,
{
   page: 22,
   name: "Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 639.585,
   left: 49.6037,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 22,
   name: "TransactionBroker in this transaction", 
   isText: false,
   type: "checkbox",
   top: 659.785,
   left: 50.2801,
   width: 10.0801,
   height: 10.080
}
,
{
   page: 22,
   name: "Customer Broker has no brokerage relationship with Buyer See  B for Brokers brokerage relationship with Seller", 
   isText: false,
   type: "checkbox",
   top: 676.284,
   left: 50.3673,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 22,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 72.575,
   left: 138.138,
   width: 435.000,
   height: 13.338
}
,
{
   page: 23,
   name: "Does_4", 
   isText: false,
   type: "checkbox",
   top: 242.16,
   left: 87.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Does Not acknowledge receipt of Earnest Money deposit Broker agrees that if Brokerage Firm is the_2", 
   isText: false,
   type: "checkbox",
   top: 242.16,
   left: 131.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 304.08,
   left: 196.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "TransactionBroker in this transaction_2", 
   isText: false,
   type: "checkbox",
   top: 304.08,
   left: 279.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Customer Broker has no brokerage relationship with Seller See  A for Brokers brokerage relationship with Buyer", 
   isText: false,
   type: "checkbox",
   top: 320.16,
   left: 51.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Seller_13", 
   isText: false,
   type: "checkbox",
   top: 359.28,
   left: 124.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Buyer_12", 
   isText: false,
   type: "checkbox",
   top: 359.28,
   left: 172.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Other_6", 
   isText: false,
   type: "checkbox",
   top: 359.28,
   left: 222.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "otherSellerBroker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 356.64,
   left: 269.84,
   width: 285.00,
   height: 12.48
}
,
{
   page: 23,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 427.956,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 441.156,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 454.356,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 467.556,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.328,
   left: 50.793,
   width: 132.000,
   height: 12.000
}
,
{
   page: 23,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.328,
   left: 315.885,
   width: 132.000,
   height: 12.000
}
,
{
   page: 23,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 493.956,
   left: 190.527,
   width: 105.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 493.956,
   left: 455.487,
   width: 95.040,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.716,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.916,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 556.116,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 569.316,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.516,
   left: 185.487,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 118.813,
   left: 194.376,
   width: 105.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 118.813,
   left: 459.336,
   width: 95.040,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.573,
   left: 189.336,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 167.773,
   left: 189.336,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 180.973,
   left: 189.336,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 194.173,
   left: 189.336,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.056,
   left: 53.3328,
   width: 136.0002,
   height: 13.000
}
,
{
   page: 23,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.056,
   left: 315.806,
   width: 136.000,
   height: 13.000
}
,
{
   page: 23,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 53.127,
   left: 188.661,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 78.635,
   left: 188.707,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 65.435,
   left: 188.707,
   width: 375.000,
   height: 12.480
}
,
{
   page: 23,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 91.835,
   left: 188.707,
   width: 375.000,
   height: 12.480
}
] }
